import { CustomCn } from '@gate31/core/src/libs/classname';
import { EventEmitter } from '@gate31/uikit/common/scripts/component-event-emitter';
import { CreateAccountFormDesk } from '../CreateAccountFormDesk/CreateAccountFormDesk';

export class WelcomePopupFormDesk {
    static cn = new CustomCn('WelcomePopupFormDesk');

    root: HTMLFormElement;
    input: HTMLInputElement;
    button: HTMLButtonElement;

    stepsList: NodeListOf<HTMLDivElement>;
    openFormButton: HTMLButtonElement;
    formStep: HTMLDivElement
    resultStep: HTMLDivElement

    dataAttrSettingHidden: string;
    ee: EventEmitter;

    constructor(root: HTMLFormElement) {
        this.root = root;
        this.input = this.root.querySelector<HTMLInputElement>(WelcomePopupFormDesk.cn.setElem('input').toSelector()) as HTMLInputElement;
        this.button = this.root.querySelector<HTMLInputElement>(WelcomePopupFormDesk.cn.setElem('button').toSelector()) as HTMLButtonElement;

        this.stepsList = this.root.querySelectorAll(WelcomePopupFormDesk.cn.setElem('Step').toSelector()) as NodeListOf<HTMLDivElement>;
        this.openFormButton = this.root.querySelector(WelcomePopupFormDesk.cn.setElem('NextOne').toSelector()) as HTMLButtonElement;
        this.formStep = this.stepsList[1];
        this.resultStep = this.stepsList[2];

        this.dataAttrSettingHidden = 'data-settings-hidden-text';
        this.ee = new EventEmitter();

        this.callbackConnection();
    }

    callbackConnection() {
        // eslint-disable-next-line
        new CreateAccountFormDesk({
            node: CreateAccountFormDesk.querySelector(CreateAccountFormDesk.cn.toSelector()),
            source: 'Pop-up',
            successHandle: () => {
                this.showResultStep?.();
            }
        });

        this.openFormButton.addEventListener('click', () => {
            this.showFormStep();
        });
    }

    hideAllSteps() {
        this.stepsList.forEach(item => {
            item.classList?.remove('show');
        });
    }

    showFormStep() {
        this.hideAllSteps();

        this.formStep?.classList.add('show');
    }

    showResultStep() {
        this.hideAllSteps();

        this.resultStep?.classList.add('show');

        // Сообщаем что модалка учпешно пройдена
        this.ee.emit('subscription-form:success', {});
    }
}
